import { render, staticRenderFns } from "./contractStatus.vue?vue&type=template&id=2373add0&scoped=true&"
import script from "./contractStatus.vue?vue&type=script&lang=js&"
export * from "./contractStatus.vue?vue&type=script&lang=js&"
import style0 from "./contractStatus.vue?vue&type=style&index=0&id=2373add0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2373add0",
  null
  
)

export default component.exports